import { abortNavigation, navigateTo } from '#app'

export default defineNuxtRouteMiddleware((to) => {
    if (import.meta.server || process.env.MODE === 'test') return

    if (to.path === '/') {
        return navigateTo(getChargemapUrl('/map'), {
            external: true
        })
    }

    const routeName = (to.name ?? '') as string

    if (routeName.includes('feedback-list')) {
        const poolId = to.params.id

        if (Number.isNaN(poolId)) {
            abortNavigation({
                statusCode: 404,
                statusMessage: 'Invalid poolId'
            })
        }
    }
})
